export default __webpack_public_path__ + "static/media/Rappid_banner.cf320f1b.png";